import ky from "ky-universal";

type SuccessStatus = "success";
type FailedStatus = "failed";
type AudienceFromLinkAPIData = {
	countryName: string;
	greeting: string;
	introduction: string;
	locationChangeText: string;
	sectionAudienceType: {
		title: string;
		audienceTypeId: string;
		isActive: boolean;
		isAffirmationRequired: boolean;
	}[];
	countrySelection: {
		title: string;
		apiUrl: string;
	};
	countryKey: string;
	apiUrl: string;
	action: string;
	status: SuccessStatus | FailedStatus;
} & Error;

const getAudienceSelectorFromLink = async (countryKey: string, apiUrl: string) => {
	const countryKeyJSON = countryKey ? JSON.stringify({ countryKey: countryKey }) : "";
	let baseUrl = window.location.origin + apiUrl;

	if (process.env.NODE_ENV !== "production") {
		baseUrl = "http://localhost:7000/audience-selector-api/get-audience-selector-from-link";
	}
	const resData:
		| {
				status: SuccessStatus;
				data: AudienceFromLinkAPIData;
		  }
		| {
				status: SuccessStatus;
				data: string;
		  }
		| {
				status: FailedStatus;
				data: Error;
		  } = await ky
		.post(baseUrl, {
			headers: new Headers({
				"Content-Type": "application/json"
			}),
			body: countryKeyJSON
		})
		.json<AudienceFromLinkAPIData>()
		.then((data) => {
			if (Object.hasOwn(data, "status")) {
				if (data.status === ("failed" as FailedStatus)) {
					console.error(data);
					// { "status": "failed", "action": "none" }
					return {
						status: data.status,
						data: data
					};
				}
				if (data.action === "reload") {
					// { status: "success", action: "reload" }
					return {
						status: data.status as SuccessStatus,
						data: data.action
					};
				}
				return {
					status: "success" as SuccessStatus,
					data: data
				};
			}
			return {
				status: "success" as SuccessStatus,
				data: data
			};
		})
		.catch((error: Error) => {
			console.error(error);
			return {
				status: "failed" as FailedStatus,
				data: error
			};
		});
	return resData;
};
export default getAudienceSelectorFromLink;
